export default "__VITE_ASSET__BY9LE_s___"